module.exports = __webpack_public_path__ + "static/media/템플릿 제작.e6bed304.jpg";